module.exports = __webpack_public_path__ + "static/media/smart-goals-large.e2065057.png";